import { commandPost, toastOk, toastError } from "@/lib/commands/api";
import {
  ExpandRadiusPanel,
  BlastDriverPanel,
  BlastCarrierPanel,
  RestartFulfillmentPanel,
} from "@/components/command-bar/panels";
import type { Command } from "@/lib/commands/types";

// Fulfillment commands need both org:dispatch:write (or
// org:dispatch:override for the destructive ones) and the
// feature_marketplace_sourcing flag. Org membership without the
// flag means the org doesn't use fulfillment — hide the entries.
export const commandsFulfillment: Command[] = [
  {
    id: "fulfillment.expand_radius",
    label: "Expand search radius",
    description: "Widen the marketplace search for this load.",
    group: "fulfillment",
    scope: "fulfillment_panel",
    hotkey: { mod: ["mod", "shift"], key: "r" },
    permission: "org:dispatch:override",
    featureFlag: "feature_marketplace_sourcing",
    handler: { kind: "panel", open: ExpandRadiusPanel },
  },
  {
    id: "fulfillment.blast_driver",
    label: "Blast a specific driver",
    group: "fulfillment",
    scope: "fulfillment_panel",
    hotkey: { mod: ["mod", "shift"], key: "b" },
    permission: "org:dispatch:write",
    featureFlag: "feature_marketplace_sourcing",
    handler: { kind: "panel", open: BlastDriverPanel },
  },
  {
    id: "fulfillment.blast_carrier",
    label: "Blast a specific carrier",
    group: "fulfillment",
    scope: "fulfillment_panel",
    permission: "org:dispatch:write",
    featureFlag: "feature_marketplace_sourcing",
    handler: { kind: "panel", open: BlastCarrierPanel },
  },
  {
    id: "fulfillment.stop",
    label: "Stop fulfillment",
    group: "fulfillment",
    scope: "fulfillment_panel",
    permission: "org:dispatch:override",
    featureFlag: "feature_marketplace_sourcing",
    confirmation: {
      title: "Stop fulfillment?",
      destructive: true,
      body: "Pending offers will be cancelled. You can restart afterwards.",
    },
    handler: {
      kind: "mutation",
      run: async (ctx) => {
        try {
          await commandPost(
            `/api/v1/fulfillment/${ctx.fulfillmentRequestId}/stop`,
            { reason: "manual_stop" },
          );
          toastOk("Fulfillment stopped");
        } catch (e) {
          toastError(e instanceof Error ? e.message : "Failed to stop");
          throw e;
        }
      },
    },
  },
  {
    id: "fulfillment.restart",
    label: "Restart fulfillment",
    group: "fulfillment",
    scope: "load_detail",
    permission: "org:dispatch:write",
    featureFlag: "feature_marketplace_sourcing",
    handler: { kind: "panel", open: RestartFulfillmentPanel },
  },
];
